<div [class.setting-disabled]="disabled">
    <nz-divider
        *ngIf="!!this.option.displayName"
        class="no-margin"
        nzPlain="true"
        [nzText]="text"
        nzOrientation="left"
    >
        <ng-template #tooltipDescription>
            <div>
                <b>{{ option.displayName }}</b>
                <p
                    style="color: #999; white-space: pre-line"
                    [innerText]="option.description"
                ></p>
            </div>
        </ng-template>

        <ng-template #text>
            <div
                class="sider-divider-text setting-divider-label"
                nz-tooltip
                [nzTooltipTitle]="
                    option.description ? tooltipDescription : null
                "
                [nzTooltipOverlayStyle]="{ 'max-width': '380px' }"
            >
                {{ option.displayName.toUpperCase() }}
                <span
                    *ngIf="option.description"
                    class="setting-documentation"
                    nz-icon
                    nzType="info-circle"
                    nzTheme="outline"
                ></span>
            </div>
        </ng-template>
    </nz-divider>

    <nz-radio-group
        [nzDisabled]="disabled"
        [ngModel]="currentValue"
        (ngModelChange)="onChange($event)"
        nzSize="small"
        nzButtonStyle="solid"
        nzName="{{ option.displayName }}"
    >
        <label
            nz-radio-button
            *ngFor="let option of this.option.selectOptions"
            [nzValue]="option"
            >{{ option.toUpperCase() }}</label
        >
    </nz-radio-group>
</div>
